import { ESortType } from './types';

export * from './types';

export function sortObjAscDescByKey<T>(array: T[], key: keyof T, sortType: ESortType): T[] {
  return array.sort((a, b) => {
    if (sortType === ESortType.ASC) {
      return a[key] > b[key] ? 1 : -1;
    } else {
      return a[key] < b[key] ? 1 : -1;
    }
  });
}

export function sortNumberAscDescByKey(array: number[], sortType: ESortType) {
  return array.sort((a, b) => {
    if (sortType === ESortType.ASC) {
      return a - b;
    } else {
      return b - a;
    }
  });
}
